import React, { PureComponent } from 'react';
import { omit, findIndex, last, size } from 'lodash';
import PropTypes from 'prop-types';

export class Image extends PureComponent {

	static propTypes = {
		src: PropTypes.string,
    fallbackSrcSet: PropTypes.arrayOf(PropTypes.string),
		width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		className: PropTypes.string,
		onReadAsFile: PropTypes.func,
		onClick: PropTypes.func,
		originalName: PropTypes.string,
    circle: PropTypes.bool
	};

	static defaultProps = {
		originalName: 'image.jpeg'
	};

	static resizeImage = (src, width, height) => {
		if (!src) return null;
		let params = [];

		if (width) {
			params.push('width=' + width);
		}

		if (height) {
			params.push('height=' + height);
		}

		if (params.length) {
			params = (src.indexOf('?') >= 0 ? "&" : "?") + params.join("&");
		}

		return src + params;
	};

	get src() {
    const { width, height, src } = this.props;
    const { currentFallbackSrc } = this.state;

    let srcToUse = src;
    if (currentFallbackSrc || !src) {
      srcToUse = currentFallbackSrc;
    }

    return Image.resizeImage(srcToUse, width, height);
  }
  
  get style() {
    const { width, circle, style } = this.props;
    return { borderRadius: circle ? width : 0, ...style };
  }

	state = {
    currentFallbackSrc: null
  };

	img = null;

	componentWillReceiveProps(nextProps) {
	  const { src } = this.props;
	  if (src !== nextProps.src) {
	    this.setState({ currentFallbackSrc: null });
    }
  }

	render() {
		const {width, circle} = this.props;
		if (!this.src) return null;
		return (
			<img {...omit(this.props, ['onReadAsFile', 'originalName', 'circle', 'fallbackSrcSet'])}
					 src={this.src}
					 ref={(img) => { this.img = img; }}
					 onClick={this.clickHandler}
           onError={this.handleError}
           style={this.style}
			/>
		)
	}

  resolveNextFallbackSrc() {
    const { fallbackSrcSet } = this.props;
    const { currentFallbackSrc } = this.state;
    const currentFallbackSrcIndex = findIndex(fallbackSrcSet, (src) => src === currentFallbackSrc);
    return fallbackSrcSet[currentFallbackSrcIndex + 1];
  }

	handleError = () => {
	  const { fallbackSrcSet } = this.props;
	  const { currentFallbackSrc } = this.state;

	  if (size(fallbackSrcSet) === 0) {
	    return;
    }

    if (currentFallbackSrc === last(fallbackSrcSet)) {
      return;
    }

    this.setState({ currentFallbackSrc: this.resolveNextFallbackSrc() });
  }

	clickHandler = () => {
		const { onClick, onReadAsFile } = this.props;
		if (onClick) {
			onClick();
		}

		if (onReadAsFile) {
			this.readAsBlob();
		}
	}

	readAsFileHandler = (result) => {
		const { onReadAsFile, originalName } = this.props;
		if (onReadAsFile) {
			result.name = originalName;
			onReadAsFile(result, this.uploadCallback);
		}
	}

	readAsBlob() {
		if (!this.img) {
			return null;
		}
		const {width, height} = this.props;
		const canvas = document.createElement("canvas");
		canvas.width = width || this.img.naturalWidth;
		canvas.height = height || this.img.naturalHeight;
		const ctx = canvas.getContext("2d");
		ctx.drawImage(this.img, 0, 0);
		return canvas.toBlob(this.readAsFileHandler, 'image/*');
	}

	uploadCallback = () => {};

}

export default Image;
